import React from "react";
import { CardContent, Box, styled } from "@mui/material";
import Card from "@mui/material/Card";

import { Typography } from "components/Typography";
import { formatToNaira } from "utils/formatCurrency";

const WidgetBox = styled(Card)(() => ({
  borderRadius: "10px",
  border: "1px solid #F1F0F5",
  width: "350px",
  padding: "10px",
  boxShadow: "0px 1px 12px 0px rgba(21, 41, 82, 0.03)",
}));

const BoxContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0px",
  color: "#50555E",
}));

const BoxContainer = styled(Box)(() => ({
  gap: "10px",
  justifyContent: "space-between",
  display: "flex",
  paddingTop: "24px",
}));

export const CircleIcon = styled(Box)(() => ({
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  border: "1px solid #D9DEDF",
}));

const formatPercentage = (value) => {
  if (value == null) return "0";
  return `${Number(value).toFixed(2)}%`;
};

export const CardContainer = ({ metrics = {} }) => {
  const cardList = [
    {
      title: "Transaction Value",
      amount: formatToNaira(metrics.transactionValue),
    },
    {
      title: "Transaction Volume",
      amount: metrics.transactionVolume ?? "—",
    },
    {
      title: <span>Total Failed &nbsp; / &nbsp; Total Successful</span>,
      amount: (
        <span>
          {metrics.totalFailed ?? "—"} / {metrics.totalSuccessful ?? "—"}
        </span>
      ),
    },
    {
      title: "% Failure",
      amount: formatPercentage(metrics.failurePercentage),
    },
  ];

  return (
    <BoxContainer>
      {cardList.map((item, index) => (
        <WidgetBox key={index}>
          <CardContent>
            <BoxContent>
              <Typography variant="dashboardBody" gutterBottom>
                {item.title}
              </Typography>
              <CircleIcon />
            </BoxContent>
            <Typography variant="dashboardHeading">{item.amount}</Typography>
          </CardContent>
        </WidgetBox>
      ))}
    </BoxContainer>
  );
};
